






















































































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { CompanyFilterValue, FetchShiftTemplateListPayload, PlanningAssistantStartEndPayload } from '@/types/payload'
import {
  PLANNING_ASSISTANT_GET_COMPANY_FILTER,
  PLANNING_ASSISTANT_GET_END_DATE,
  PLANNING_ASSISTANT_GET_START_DATE,
  GET_SELECTED_UI_LANGUAGE,
  COMPANY_GET_BASIC_COMPANY_STRUCTURE,
  GET_SECURITY_DATA,
  PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING, PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST
} from '@/store/getter-types'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'
import {
  FETCH_PRESELECTED_EMPLOYEE,
  LOAD_SHIFT_TEMPLATE_LIST,
  PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_SET_START_END_DATA, PLANNING_SEARCH_PROJECT_LIST, SEARCH_ADDRESS_BY_ID, SEARCH_ADDRESS_LIST
} from '@/store/action-types'
import { ActionsEnum } from '@/types/enums'
import { Address } from '@/model/planning/Address'
import { ProfitCenter } from '@/model/companyStructure/ProfitCenter'
import { CompanyStructure } from '@/types'
import { Employee } from '@/model/companyStructure/Employee'
import { SecurityData } from '@/model/SecurityData'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { AutomaticOneResponse, PlanungLookupProjekteResponse } from '@/types/service-response'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import { PlanningLookupProject } from '@/model/planning/PlanningLookupProject'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection, DxSorting } from 'devextreme-vue/data-grid'

interface ComponentData {
  dateStartIso: string
  dateEndIso: string
  hourStart: string
  hourEnd: string
  minuteStart: string
  minuteEnd: string
  hourRules: Array<Function>
  minuteRules: Array<Function>
  showErrorBadTime: boolean
  shiftTemplateList: Array<ShiftTemplate>
  selectedShiftTemplateId: number | undefined
  selectedAddress: Address | undefined
  addressList: Array<Address>
  search: string | null
  isLoading: boolean
  selected: boolean
  selectedProject: PlanningLookupProject | null
  projectList: PlanningLookupProject[]
  projectSearchText: string | null
  projectLoading: boolean
  foundProfitCenterData: ProfitCenter | undefined
  showAddressSelect: boolean
  showProjectSelect: boolean
  menu: boolean
}

export default Vue.extend({
  name: 'ShiftEditorStartEnd',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSorting,
    DxSelection
  },

  props: {
    action: {
      type: String as () => ActionsEnum
    },
    editShift: Object as () => EditShiftPlan | undefined,
    templateList: Array as () => Array<ShiftTemplate>,
    editShiftAddressId: Number
  },

  computed: {
    dateEndFormatted (): string {
      return moment(this.dateEndIso, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    dateStartFormatted (): string {
      return moment(this.dateStartIso, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    dateStart (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
    },

    companyFilter (): CompanyFilterValue {
      return this.$store.getters[PLANNING_ASSISTANT_GET_COMPANY_FILTER]
    },

    isDataValid (): boolean {
      const conditions = [
        ((): boolean => {
          const start = moment(`${this.dateStartIso} ${this.hourStart}:${this.minuteStart}`)
          const end = moment(`${this.dateEndIso} ${this.hourEnd}:${this.minuteEnd}`)

          return start.isBefore(end)
        })()
      ]

      return conditions.every(v => v)
    },

    isTemplateDisabled (): boolean {
      return (this.action === ActionsEnum.EDIT)
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    companyStructure(): CompanyStructure {
      return this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]
    },

    foundAddressList (): Array<Address> {
      return this.addressList
    },

    filteredProjectList (): PlanningLookupProject[] {
      if(this.projectSearchText) {
        return this.projectList.filter((item: PlanningLookupProject) => item.label.toLowerCase().includes(this.projectSearchText!.toLowerCase()))
      } else {
        return this.projectList
      }
    }
  },

  watch: {
    search (newVal: string): void {
      // Items have already been requested
      if (this.isLoading) return

      // Lazily load input items
      if(newVal && newVal.length > 2 && !this.selected) {
        this.searchAddress()
      }

      this.selected = false

      if (newVal === null) {
        this.selectDefaultAddress()
        this.selected = true
      }
    },

    selectedAddress (newVal: Address | undefined): void {
      if(newVal && newVal.id && !this.editShift) {
        this.searchProject(newVal.id)
        this.fetchPreSelectedEmployee(newVal.id)
      }
    },

    menu (newVal: boolean): void {
      if(newVal) {
        //@ts-ignore
        setTimeout(() => { this.$refs.dataGrid.instance.refresh() }, 0)
      }
    }
  },

  data (): ComponentData {

    const todayIso = moment().format('YYYY-MM-DD')

    return {
      dateStartIso: todayIso,
      dateEndIso: todayIso,
      hourStart: '00',
      hourEnd: '00',
      minuteStart: '00',
      minuteEnd: '00',

      hourRules: [
        (v: string) => !!v || this.$t('planningPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 24) || this.$t('planningPage.badValue')
        }
      ],

      minuteRules: [
        (v: string) => !!v || this.$t('planningPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 60) || this.$t('planningPage.badValue')
        }
      ],

      showErrorBadTime: false,
      shiftTemplateList: [],
      selectedShiftTemplateId: undefined,
      selectedAddress: undefined,
      addressList: [],
      search: null,
      isLoading: false,
      selected: false,
      selectedProject: null,
      projectList: [],
      projectSearchText: null,
      projectLoading: false,
      foundProfitCenterData: undefined,
      showAddressSelect: false,
      showProjectSelect: false,
      menu: false
    }
  },

  methods: {
    onFieldStartChange (): void {
      this.dateEndIso = this.dateStartIso
      this.onFieldValueChange()
    },

    onFieldEndChange (): void {
      this.onFieldValueChange()
    },

    // <editor-fold desc="Event Handlers">
    onFieldValueChange (): void {
      const startMinutes: number = parseInt(this.hourStart) * 60 + parseInt(this.minuteStart)
      const endMinutes: number = parseInt(this.hourEnd) * 60 + parseInt(this.minuteEnd)

      if (startMinutes > endMinutes) {
        this.dateEndIso = moment(moment(this.dateStartIso).add(1, 'day')).format('YYYY-MM-DD')
      } else {
        this.dateEndIso = this.dateStartIso
      }

      if (this.isDataValid) {
        this.showErrorBadTime = false
        this.updateStoreValues()
      } else {
        this.showErrorBadTime = true
      }
    },

    onTemplateSelect (templateId: number): void {
      const templateItem: ShiftTemplate = _.find(this.shiftTemplateList, { id: templateId })! as ShiftTemplate

      this.hourStart = this.formatHour(templateItem.startDate)
      this.minuteStart = this.formatMinute(templateItem.startDate)

      this.hourEnd = this.formatHour(templateItem.endDate)
      this.minuteEnd = this.formatMinute(templateItem.endDate)

      this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, [])
      this.onFieldValueChange()
    },

    onAddressSelect (): void {
      this.$emit('selectedAddress', this.selectedAddress)
      this.selected = true
    },

    async searchAddress(): Promise<void> {
      this.isLoading = true
      try {
        const data: Array<Address> = await this.$store.dispatch(SEARCH_ADDRESS_LIST, this.search)
        this.addressList = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },

    async searchAddressById (addressId: number): Promise<void> {
      const foundAddress: Array<Address> = await this.$store.dispatch(SEARCH_ADDRESS_BY_ID, addressId)
      if(foundAddress && foundAddress[0]) {
        this.selectedAddress = foundAddress[0]
        this.addressList = [this.selectedAddress]
        this.selected = true
        this.onAddressSelect()
        this.searchProject(addressId)
      }
    },

    selectDefaultAddress (): void {
      if(this.foundProfitCenterData) {
        if(this.editShift && this.editShiftAddressId) {
          this.searchAddressById(this.editShiftAddressId)
        } else {
          this.searchAddressById(this.foundProfitCenterData.addressId)
        }
      } else {
        this.selectedAddress = undefined
      }
    },

    formatDate(item: string): string {
      return moment(item).isValid() ? moment(item).format('DD.MM.YYYY') : ''
    },

    onRowClick (data: any): void {
      if(data && data.data) {
        this.selectedProject = data.data
        this.projectSearchText = this.selectedProject!.label
        this.$emit('selectedProject', this.selectedProject)
      }
    },

    onProjectClear (): void {
      this.onFocusProject()
    },

    onFocusProject (): void {
      setTimeout(() => {
        if(!this.menu) {
          this.menu = true
        }
      }, 200)
    },

    onBlurProject (): void {
      setTimeout(() => {
        if(this.menu) {
          this.menu = false
        }
      }, 100)
    },

    /*onProjectSelect (): void {
      this.$emit('selectedProject', this.selectedProject)
    },*/

    async searchProject(addressId: number): Promise<void> {
      this.projectLoading = true
      try {
        const response: PlanungLookupProjekteResponse = await this.$store.dispatch(PLANNING_SEARCH_PROJECT_LIST, addressId)
        if(response && !response.IsError && response.Data) {
          this.projectList = PlanningLookupProject.createListFromResponse(response.Data)
          if(this.editShift) {
            const foundProject: PlanningLookupProject | undefined = this.projectList.find((item: PlanningLookupProject) => item.id === this.editShift!.referenzProjektId)
            this.selectedProject = foundProject ? foundProject : null
            this.projectSearchText = this.selectedProject ? this.selectedProject.label : null
            if(this.selectedProject) {
              this.$emit('selectedProject', this.selectedProject)
            }
          }
          this.projectLoading = false
        }
      } catch {
        this.projectLoading = false
      }
    },

    // </editor-fold>

    // <editor-fold desc="Date Formatters">
    formatDateIso (date: Date): string {
      return moment(date).format('YYYY-MM-DD')
    },

    formatHour (date: Date): string {
      return moment(date).format('HH')
    },

    formatMinute (date: Date): string {
      return moment(date).format('mm')
    },
    // </editor-fold>

    // <editor-fold desc="Date Normalization">
    normalizeDateStart (): Date {
      const dateStart = this.dateStartIso
      const hourStart = this.hourStart
      const minuteStart = this.minuteStart

      const dateStr = `${dateStart} ${hourStart.padStart(2, '0')}:${minuteStart.padStart(2, '0')}`

      return moment(dateStr).toDate()
    },

    normalizeDateEnd (): Date {
      const dateEnd = this.dateEndIso
      const hourEnd = this.hourEnd
      const minuteEnd = this.minuteEnd

      const dateStr = `${dateEnd} ${hourEnd.padEnd(2, '0')}:${minuteEnd.padEnd(2, '0')}`

      return moment(dateStr).toDate()
    },
    // </editor-fold>

    updateStoreValues () {
      const templateItem: ShiftTemplate | undefined = _.find(this.shiftTemplateList, { id: this.selectedShiftTemplateId }) as ShiftTemplate

      const payload: PlanningAssistantStartEndPayload = {
        dateStart: this.normalizeDateStart(),
        dateEnd: this.normalizeDateEnd(),
        shiftTemplateItem: templateItem
      }

      this.$store.dispatch(PLANNING_ASSISTANT_SET_START_END_DATA, payload)

      let plannedEmployeeList: PlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
      plannedEmployeeList = plannedEmployeeList.map((item: PlannedEmployee) => {
        return item.updateStartEnd(this.normalizeDateStart(), this.normalizeDateEnd())
      })

      this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, plannedEmployeeList)
    },

    async fetchPreSelectedEmployee (item: number): Promise<void> {
      try {
        const response: AutomaticOneResponse = await this.$store.dispatch(FETCH_PRESELECTED_EMPLOYEE, item)
        if(!response.IsError && response.Data && response.Data.Mitarbeiter) {
          const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
          const foundEmployee: EmployeeAvailableForPlanning | undefined = availableEmployeeList.find((item: EmployeeAvailableForPlanning) => item.id === response.Data.Mitarbeiter)
          if(foundEmployee) {
            const selectedEmployee: PlannedEmployee = new PlannedEmployee(
                foundEmployee.id,
                foundEmployee.name,
                foundEmployee.capacity,
                foundEmployee.isFloater,
                foundEmployee.competenceName,
                '',
                this.dateStart,
                this.dateEnd,
                foundEmployee.planingGroupName,
                undefined,
                undefined,
                undefined,
                undefined
            )

            this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, [selectedEmployee])
          }
        }
      } catch {

      }
    }
  },

  async mounted () {

    this.dateStartIso = this.formatDateIso(this.dateStart)
    this.hourStart = this.formatHour(this.dateStart)
    this.minuteStart = this.formatMinute(this.dateStart)

    this.dateEndIso = this.formatDateIso(this.dateEnd)
    this.hourEnd = this.formatHour(this.dateEnd)
    this.minuteEnd = this.formatMinute(this.dateEnd)

    if (this.companyFilter.department) {
      const payload: FetchShiftTemplateListPayload = {
        departmentId: this.companyFilter.department.id
      }
      /*if(this.templateList && this.templateList.length > 0) {
        this.shiftTemplateList = this.templateList
      } else {*/
      const data = await this.$store.dispatch(LOAD_SHIFT_TEMPLATE_LIST, payload)
      this.shiftTemplateList = _.sortBy(data, [function(o) { return o.description.toLocaleLowerCase(); }])
      //}
      if(this.editShift && this.editShift.shiftId) {
        this.selectedShiftTemplateId = this.editShift.shiftId
      }
    }

    const userId = this.$store.state.currentUser.id
    const user: Employee | undefined = this.companyStructure.employeeList.find((item: Employee) => userId === item.id)
    if (user) {
      this.foundProfitCenterData = this.companyStructure.profitCenterList.find((item: ProfitCenter) => user.profitCenter === item.id)
      this.selectDefaultAddress()
    }
    const securityData = this.$store.getters[GET_SECURITY_DATA]
    const filteredData = securityData.filter((item: SecurityData) => item.area === 'planning')
    this.showAddressSelect = filteredData.find((item: SecurityData) => (item.component === 'selectbox-adress')).visibility
    this.showProjectSelect = filteredData.find((item: SecurityData) => (item.component === 'selectbox-project')).visibility

    if(this.action !== ActionsEnum.EDIT) {
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    }
  }
})
